module.exports = __webpack_public_path__ + "img/icon_task_active.ac5bc00c.png";